<template>
  <customer-details>
    <template v-slot:btnPrope>
      <v-btn
        class="t-btn--prm mr-5 ml-2"
        :disabled="!checkPerUser"
        @click="saveData"
      >
        保存
      </v-btn>
    </template>

    <div class="mx-5 mt-5">
      <h2 class="color-blue--drank mb-5">TVPポイント利用制限</h2>
      <v-card outlined class="pa-5">
        <v-checkbox
          class="checkbox-custom mt-0 pt-0"
          hide-details
          label="ポイント利用不可"
          v-model="restrictTVP"
          :disabled="!checkPerUser"
          slim
        ></v-checkbox>
      </v-card>
    </div>
  </customer-details>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomerDetails from '../CustomerDetails.vue';
import { checkPermissionUserCurrent } from '@/utils/permissions';

export default {
  name: 'customer-detail-tvp-restrict',
  components: { CustomerDetails },
  data() {
    return {
      checkPerUser: checkPermissionUserCurrent(this.$router.currentRoute),
    };
  },
  computed: {
    ...mapGetters(['getClientRestrictTVP']),
    restrictTVP: {
      get() {
        return this.getClientRestrictTVP;
      },
      set(value) {
        this.setClientRestrictTVP(value);
      },
    },
  },
  mounted() {
    this.loadClientRestrictTVP(this.$route.params.id);
  },
  methods: {
    ...mapActions(['loadClientRestrictTVP', 'updateClientRestrictTVP']),
    ...mapMutations(['setClientRestrictTVP']),
    async saveData() {
      await this.updateClientRestrictTVP(this.$route.params.id);
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px !important;
  color: #0c6786;
  font-weight: bold !important;
}
.color-blue--drank {
  color: #004f8b !important;
}
.checkbox-custom {
  margin-top: 0px !important;
}
</style>
